module.exports = __webpack_public_path__ + "static/img/k2hqdmpfendk2hqdmpfend.ba552f59.jpg";